/** Ровный шаг 60 Гц из накопителя, не больше 4 шагов за кадр экрана; рисование — раз за кадр экрана (GAME-01). */
export const STEP_MS = 1000 / 60;
const MAX_STEPS = 4;

export function startLoop(tick: () => void, render: () => void): () => void {
  let last = performance.now();
  let accumulator = 0;
  let running = true;
  const frame = (now: number): void => {
    if (!running) return;
    accumulator += Math.min(now - last, 250);
    last = now;
    let steps = 0;
    while (accumulator >= STEP_MS && steps < MAX_STEPS) {
      tick();
      accumulator -= STEP_MS;
      steps++;
    }
    if (steps === MAX_STEPS) accumulator = 0;
    render();
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
  return () => {
    running = false;
  };
}
